import { getColors, SIZES } from '../constants';

/**
 * Рисует вертикальный разделитель.
 * @returns ширина области (включая отступы)
 */
export function drawSeparator(ctx: CanvasRenderingContext2D, x: number, y: number): number {
    const lineX = x + SIZES.separatorMarginX;
    const halfHeight = SIZES.separatorHeight / 2;

    ctx.save();
    ctx.strokeStyle = getColors().separator;
    ctx.lineWidth = SIZES.separatorWidth;
    ctx.beginPath();
    ctx.moveTo(lineX, y - halfHeight);
    ctx.lineTo(lineX, y + halfHeight);
    ctx.stroke();
    ctx.restore();

    return SIZES.separatorMarginX * 2 + SIZES.separatorWidth;
}
